import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const NotFound = () => {
    return (
        <div className="container p-5">
            <h2 className="text-danger fw-thin">Page Not Found!</h2>
            <img
                className="img-fluid"
                src="https://i.ibb.co/zVdrC4m/Page-404-Link-to-non-existent-page-Space-astronomy-The-astronaut-is-flying-in-a-hot-air-balloon.jpg"
                alt="Page-not-found"
            />
            <br />
            <Link to="/">
                <Button className="fs-4" variant="tranparent text-success">
                    Go To Home
                </Button>
            </Link>

            <div>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
            </div>
        </div>
    );
};

export default NotFound;
